import { defaultThClass } from '../../../config'

const defaultClass = {
  tdClass: '!font-[400] text-[#333333]',
  class: `${defaultThClass} !text-[14px] !min-w-[180px] !text-[#333333] !align-middle`,
}

const fieldsDetailPenarikan = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
  {
    key: 'variant_name',
    label: 'Variasi',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
    formatter: value => value || '-',
  },
  {
    key: 'total_product',
    label: 'Jumlah Pengajuan',
    thClass: defaultClass.class,
    tdClass: defaultClass.tdClass,
  },
]

export default fieldsDetailPenarikan
